/**
 * Modale Bootstrap di scelta del colore delega (form con il gruppo radio shared-scelta-colore).
 * La modale viene spostata su body per evitare problemi di z-index/backdrop.
 */
type SalvaColore = (coloreId: number) => Promise<boolean>;

export class ModaleColore {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private modal: any;
  private onSalva: SalvaColore | null = null;

  constructor(private el: HTMLElement) {
    document.body.appendChild(el);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.modal = new (globalThis as any).bootstrap.Modal(el);
    el.querySelector('form')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.salva();
    });
  }

  /** Apre la modale con il colore attuale preselezionato (se ancora valido) */
  apri(titolo: string, coloreId: number | null, onSalva: SalvaColore): void {
    this.onSalva = onSalva;
    const titoloEl = this.el.querySelector('[data-colore-titolo]');
    if (titoloEl) titoloEl.textContent = titolo;
    this.el.querySelectorAll<HTMLInputElement>('input[name="colore"]').forEach(radio => {
      radio.checked = Number(radio.value) === coloreId && !radio.closest('[data-colore-non-valido]');
    });
    this.modal.show();
  }

  dispose(): void {
    this.modal?.dispose();
    this.el.remove();
  }

  private async salva(): Promise<void> {
    const checked = this.el.querySelector('input[name="colore"]:checked') as HTMLInputElement | null;
    if (!checked) {
      Weext.toast('Seleziona un colore', { type: 'warning' });
      return;
    }
    const btn = this.el.querySelector('[data-colore-salva]') as HTMLButtonElement | null;
    if (btn) btn.disabled = true;
    const ok = await this.onSalva?.(Number(checked.value));
    if (btn) btn.disabled = false;
    if (ok) this.modal.hide();
  }
}
